import { useEffect, useState } from "react";
import api from "@/lib/api";
import MarketingShell from "@/components/MarketingShell";
import { Sparkles } from "lucide-react";

export default function About() {
  const [content, setContent] = useState(null);
  useEffect(() => { api.get("/site-content").then(({ data }) => setContent(data)); }, []);
  const a = content?.about;

  return (
    <MarketingShell content={content} current="about">
      <section className="max-w-4xl mx-auto px-6 lg:px-10 pt-16 pb-12 animate-fade-up">
        <span className="label-eyebrow text-mr-accent">About</span>
        <h1 className="font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-mr-primary mt-3">{a?.title || "About MedRewards"}</h1>
        <p className="text-mr-secondary text-xl leading-relaxed mt-6">{a?.intro}</p>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 pb-16">
        <div className="prose prose-lg max-w-none">
          {(a?.body || "").split(/\n\n+/).map((p, i) => (
            <p key={i} className="text-mr-primary text-base leading-relaxed mt-4 first:mt-0 whitespace-pre-line">{p}</p>
          ))}
        </div>
      </section>

      {a?.values?.length > 0 && (
        <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
          <h2 className="font-display text-3xl font-semibold text-mr-primary mb-8">What we stand for</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {a.values.map((v, i) => (
              <div key={i} className="bg-white border border-mr rounded-2xl p-7 animate-fade-up" style={{ animationDelay: `${i * 80}ms` }}>
                <Sparkles className="h-6 w-6 text-mr-accent" />
                <h3 className="font-display text-xl font-semibold mt-4 text-mr-primary">{v.title}</h3>
                <p className="text-mr-secondary mt-2 leading-relaxed">{v.body}</p>
              </div>
            ))}
          </div>
        </section>
      )}
    </MarketingShell>
  );
}
